import { Link } from 'react-router-dom';
import { useNavigate, useLocation } from 'react-router-dom';

const footerLinks = {
  servicos: [
    { label: 'Due Diligence', anchor: '#servicos' },
    { label: 'Fusões & Aquisições', anchor: '#servicos' },
    { label: 'Estratégia Empresarial', anchor: '#servicos' },
    { label: 'Reestruturação', anchor: '#servicos' },
    { label: 'Captação de Investimento', anchor: '#servicos' },
    { label: 'Marketing, Comunicação e Branding', anchor: '#servicos' },
  ],
  empresa: [
    { label: 'Sobre Nós', anchor: '#sobre' },
    { label: 'A Nossa Equipa', anchor: '#equipa' },
    { label: 'Metodologia', anchor: '#metodologia' },
    { label: 'Contacto', anchor: '#contacto' },
  ],
};

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNav = (anchor: string) => {
    if (location.pathname === '/') {
      const el = document.querySelector(anchor);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/' + anchor);
    }
  };

  return (
    <footer className="bg-[#F5F2EE]">
      {/* Transition gap */}
      <div className="h-16" />

      <div className="bg-[#011820] rounded-t-3xl">
      {/* Main content */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">

          {/* Brand col */}
          <div className="lg:col-span-4">
            <img
              src="https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/9c157f82946044e199e259196c8a09bc.png"
              alt="MoveMind Consulting"
              className="h-10 w-auto object-contain brightness-0 invert mb-5"
            />
            <p className="text-white/45 text-sm leading-relaxed mb-7 max-w-xs">
              Transformamos desafios em oportunidades de sucesso com rigor, inovação e excelência.
            </p>
            <div className="flex flex-col gap-2.5">
              <a href="tel:+244925434499" className="text-white/45 hover:text-white text-sm flex items-center gap-2.5 transition-colors duration-200 cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-[#026A86]" />
                </span>
                +244 925 434 499
              </a>
              <a href="mailto:geral@movemind.ao" className="text-white/45 hover:text-white text-sm flex items-center gap-2.5 transition-colors duration-200 cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-[#026A86]" />
                </span>
                geral@movemind.ao
              </a>
            </div>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="https://www.linkedin.com/company/movemindconsulting/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-8 h-8 flex items-center justify-center bg-white/5 hover:bg-[#026A86] rounded-full transition-all duration-200 cursor-pointer text-white/45 hover:text-white"
              >
                <i className="ri-linkedin-line text-sm" />
              </a>
              <a
                href="https://www.instagram.com/movemindconsulting?igsh=MWwxZ3Yyc3N5c2g0cA=="
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-8 h-8 flex items-center justify-center bg-white/5 hover:bg-[#026A86] rounded-full transition-all duration-200 cursor-pointer text-white/45 hover:text-white"
              >
                <i className="ri-instagram-line text-sm" />
              </a>
            </div>
          </div>

          {/* Spacer */}
          <div className="hidden lg:block lg:col-span-1" />

          {/* Services */}
          <div className="lg:col-span-3">
            <h4 className="text-white font-semibold text-xs uppercase tracking-widest mb-5">
              Serviços
            </h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.servicos.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.anchor}
                    onClick={(e) => { e.preventDefault(); handleNav(link.anchor); }}
                    className="text-white/45 hover:text-[#026A86] text-sm transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="lg:col-span-4">
            <h4 className="text-white font-semibold text-xs uppercase tracking-widest mb-5">
              Empresa
            </h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.empresa.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.anchor}
                    onClick={(e) => { e.preventDefault(); handleNav(link.anchor); }}
                    className="text-white/45 hover:text-[#026A86] text-sm transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/25 text-xs">
            © 2024 MoveMind Consulting. Todos os direitos reservados.
          </p>

          <div className="flex items-center gap-5">
            <Link to="/termos-de-uso" className="text-white/25 hover:text-white/60 text-xs transition-colors duration-200 cursor-pointer">
              Termos de Uso
            </Link>
            <Link to="/politica-de-privacidade" className="text-white/25 hover:text-white/60 text-xs transition-colors duration-200 cursor-pointer">
              Política de Privacidade
            </Link>
          </div>
        </div>
      </div>
      </div>
    </footer>
  );
}
